// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af6a83b7","239":"7600a7e0","453":"84780bf3","455":"60ca76f4"}[chunkId] + ".chunk.js";
};